import { render, staticRenderFns } from "./ReportFormOri.vue?vue&type=template&id=4077329c&scoped=true&"
import script from "./ReportFormOri.vue?vue&type=script&lang=js&"
export * from "./ReportFormOri.vue?vue&type=script&lang=js&"
import style0 from "./ReportFormOri.vue?vue&type=style&index=0&id=4077329c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4077329c",
  null
  
)

component.options.__file = "ReportFormOri.vue"
export default component.exports